import Component from '../core/Component.js'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries, CMS } from '../core/config'

export const defaults = {
    cellSelector: '[data-ref="item"]',
    prevNextButtons: false,
    cellAlign: 'left',
    autoplay: true,
    lazyLoad: 2,
    responzive: true,
    resize: true,
    percentPosition: true,
    selectedAttraction: 0.1,
    friction: 0.8,
    contain: true,
    media: ''
}

export const STATES = {
    READY: 'is-ready',
    DISABLED: 'is-disabled'
}

export default class SideSlider extends Component {
    constructor(element, options = {}) {
        super(element, defaults)

        this.ref = {
            slider: null,
            items: [],
            prev: null,
            next: null
        }

        this.options = options
        this.flickity = null
        this.index = 0

        this.enquireHandler = null

        if (this.options.media) {
            this.enquireQuery = this.options.media in queries ? queries[this.options.media] : this.options.media
            this.enquireHandler = {
                match: ::this.attach,
                unmatch: ::this.detach
            }
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        if (this.enquireHandler) {
            enquire.register(this.enquireQuery, this.enquireHandler)
        } else {
            this.initSlider()
        }
    }

    destroy() {
        if (this.enquireHandler) {
            enquire.unregister(this.enquireQuery, this.enquireHandler)
        }
        this.destroySlider()
    }

    attach() {
        this.initSlider()
    }

    detach() {
        this.destroySlider()
    }

    initSlider() {
        if (!this.flickity) {
            this.element.classList.add(STATES.READY)

            this.flickity = new Flickity(this.ref.slider, this.options)

            if (this.ref.prev) {
                this.ref.prev.addEventListener('click', this.previous)
            }
            if (this.ref.next) {
                this.ref.next.addEventListener('click', this.next)
            }

            this.flickity.on('change', ::this.changeSlide );

            this.ref.items.map(($element, index) => {
                let $link = $element.querySelector('a')

                if ($link) {
                    $link.addEventListener('focus', event => {
                        this.flickity.select(index)
                    })
                }
            })
        }
    }

    destroySlider() {
        if (this.flickity) {
            this.element.classList.remove(STATES.READY)
            this.flickity.destroy()

            if (this.ref.prev) {
                this.ref.prev.removeEventListener('click', this.previous)
            }

            if (this.ref.next) {
                this.ref.next.removeEventListener('click', this.next)
            }

        }
    }

    changeSlide(index) {
        if (index == 0) {
            this.ref.prev && this.ref.prev.classList.add(STATES.DISABLED)
        } else {
            this.ref.prev && this.ref.prev.classList.remove(STATES.DISABLED)
        }

        let spaceLeft = this.flickity.slideableWidth - this.flickity.size.width
        let pos = (index > this.index) ? Math.abs(this.flickity.slides[index].x) + this.flickity.slides[index].outerWidth : 0

        if (pos >= spaceLeft) {
            this.ref.next && this.ref.next.classList.add(STATES.DISABLED)
        } else {
            this.ref.next && this.ref.next.classList.remove(STATES.DISABLED)
        }

        this.index = index
    }

    next = event => {
        event.preventDefault()
        this.flickity.next()
    }

    previous = event => {
        event.preventDefault()
        this.flickity.previous()
    }
}
